import get from 'lodash/get';
import { isEmpty } from 'lodash';
import { t } from 'i18next';

export const transformPurposes = purposes => {
  if (isEmpty(purposes)) return [];
  return purposes.map(p => {
    let label = p;
    if (p === 'VISIT_PERSON') {
      label = t(p);
    }
    return {
      value: p,
      type: 'text',
      display: label,
      doNotShow: false,
    };
  });
};

export const transformFormPurposes = purposes => {
  if (isEmpty(purposes)) return [];
  return purposes.map(p => {
    let value = p;
    if (p === 'VISIT_PERSON') {
      value = t(p);
    }
    return {
      purpose: {
        value: p,
        type: 'text',
        displayValue: value,
      },
    };
  });
};
export const transformSiteForm = data => {
  const {
    locations,
    manageVisitors,
    requiresIdPhoto,
    requiresPass,
    requiresPhoto,
    requiresPhone,
    purposes,
    address,
    name,
    regionId,
    regionName,
    securityCompanyId,
    securityCompanyName,
    timezone,
    inductionRequired,
    details,
    contactData,
    newSiteContact,
    contact,
    siteId,
    surfaces = [],
    ...rest
  } = data;
  return {
    siteId,
    address,
    surfaces,
    name,
    regionId,
    regionName,
    securityCompanyId,
    securityCompanyName,
    timezone,
    ...(rest?.departmentIds && { departmentIds: rest.departmentIds }),
    businessClient: {
      ...rest.businessClient,
      businessClientName: get(rest, 'businessClient.name'),
    },
    contact: newSiteContact ? contactData : contact ? contact : null,
    archived: get(data, 'archived', false),
    boundary: {
      points: locations[0].paths.map(point => ({
        latitude: point.lat,
        longitude: point.lng,
      })),
      centreOfGravity: locations[0].paths.reduce(
        (acc, point, idx) => {
          const totalNumberOfElements = point.length;
          if (totalNumberOfElements - 1 === idx) {
            return {
              latitude: (acc.latitude + point.lat) / totalNumberOfElements,
              longitude: (acc.latitude + point.lng) / totalNumberOfElements,
              radius: 100,
            };
          } else {
            return {
              latitude: acc.latitude + point.lat,
              longitude: acc.latitude + point.lng,
              radius: 100,
            };
          }
        },
        {
          latitude: 0,
          longitude: 0,
          radius: 100,
        },
      ),
    },
    visitorPolicy: {
      managesVisitors: manageVisitors,
      requiresIdPhoto,
      requiresPass,
      requiresPhoto,
      requiresPhone,
      purposes,
    },
    inductionRequired,
    details,
  };
};
